import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bikeRackFilled"
const BikeRackFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M19.125 3.563V3.937C19.125 4.767 18.453 5.438 17.625 5.438H15.873L17.62 11.455Q17.808 11.438 18 11.437C20.589 11.438 22.688 13.538 22.688 16.125 22.688 18.714 20.588 20.813 18 20.813 15.411 20.813 13.313 18.713 13.313 16.125 13.313 14.324 14.329 12.76 15.819 11.975L15.675 11.481 10.43 14.59C10.596 15.07 10.687 15.587 10.687 16.125 10.688 18.714 8.59 20.813 6 20.813S1.313 18.713 1.313 16.125C1.313 13.536 3.41 11.438 6 11.438 7.377 11.438 8.615 12.032 9.472 12.978L9.956 12.69 7.688 8.438H6.375C5.857 8.438 5.438 8.018 5.438 7.5S5.858 6.563 6.375 6.563H10.5C11.018 6.563 11.438 6.983 11.438 7.5S11.018 8.438 10.5 8.438H9.812L11.57 11.733 15.136 9.621 13.377 3.563zM6 13.313C4.447 13.313 3.188 14.572 3.188 16.125S4.447 18.938 6 18.938 8.813 17.678 8.813 16.125Q8.81 15.844 8.759 15.579L6.479 16.931C6.032 17.195 5.457 17.048 5.193 16.603S5.077 15.583 5.522 15.32L7.802 13.967C7.314 13.558 6.686 13.312 6 13.312M18.9 15.863C19.045 16.362 18.76 16.882 18.262 17.026 17.764 17.17 17.244 16.884 17.1 16.387L16.36 13.84C15.65 14.35 15.188 15.184 15.188 16.125 15.188 17.678 16.447 18.938 18 18.938S20.813 17.678 20.813 16.125C20.813 14.625 19.639 13.4 18.16 13.317z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BikeRackFilledIcon
